<template>
  <div class="todo-list">
    <!-- <div class="todo-heading">The Main Steps!</div> -->
    <todo-item
      v-for="item in items"
      :id="item.id"
      :label="item.label"
      :checked="item.checked"
      :action="item.action"
      :assignment="assignment"
      :key="item.id"
    ></todo-item>
  </div>
</template>

<script>
import TodoItem from "./TinyTodoItem";
import DownloadManuscript from "./Actions/DownloadManuscript";
import ViewOnAmazon from "./Actions/ViewOnAmazon";
import TurnInReview from "./Actions/TurnInReview";

export default {
  name: "TodoList",
  components: { TodoItem },
  props: ["assignment"],
  data: function() {
    return {
      items: [
        {
          id: 1,
          checked: this.assignment.todos ? this.assignment.todos[1] : false,
          label: "Access the Book",
          action: "download-manuscript"
        },
        {
          id: 2,
          checked: this.assignment.todos ? this.assignment.todos[2] : false,
          label: "Read the book"
        },
        {
          id: 3,
          checked: this.assignment.todos ? this.assignment.todos[3] : false,
          label: "Post your review on Amazon",
          action: "view-on-amazon"
        },
        {
          id: 4,
          checked: this.assignment.todos ? this.assignment.todos[4] : false,
          label: "Turn in this assignment on Pubby",
          action: "view-on-amazon"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.todo-list {
  margin-bottom: 30px;
  padding: 0 0 0 2px;
  font-family: $font-family;
}
.todo-heading {
  font-size: 13pt;
  font-weight: 600;
  margin-bottom: 1em;
  color: #7e57c2;
}
</style>

